/* Project Import will be here */
import { includes } from "lodash"
import { getTranslate } from "react-localize-redux";
/* Project Import will be here */

/* Project Import will be here */
import { getSalesReturnReasonsApi, getExchangeReturnReasonsApi } from "../services/salesReturn/productSalesReturn";
import { getErrorObject, errorToast, successToast, infoToast, warningToast } from "../utilities/utils";
import {
    navigateToHome,
    navigateToProductList
} from "app/navigation";
import Constants from "utilities/appConstants";
import { IGeoLocationModel } from "models/commonModels";
import { push } from "connected-react-router";
import { logOut } from "reducers/session";
import { GAPushNotification } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

/* Const,Let & Var will be here */
let noAppDataDisplayedCount = 0;
let appForceLogoutDisplayedCount = 0;
/* Const,Let & Var will be here */

export const types = {
    CHANGE_PRODUCT_TAB: "Common/ChangeProductTab",
    SALES_RETURN_REASON_REQUEST: "Common/SalesReturnReasonRequest",
    SALES_RETURN_REASON_SUCCESS: "Common/SalesReturnReasonSuccess",
    SALES_RETURN_REASON_FAILURE: "Common/SalesReturnReasonFailure",
    EXCHANGE_RETURN_REASON_REQUEST: "Common/ExchangeReturnReasonRequest",
    EXCHANGE_RETURN_REASON_SUCCESS: "Common/ExchangeReturnReasonSuccess",
    EXCHANGE_RETURN_REASON_FAILURE: "Common/ExchangeReturnReasonFailure",
    SET_PRODUCT_DETAILS_SELECTED_PRODUCT_ID: "Common/ProductDetailsSelectedProductId",
    SET_RETAILER_CURRENT_POSITION: "Common/RetailerCurrentPosition",
    SET_FAILED_REQUEST_URL: "Common/SetFailedRequestUrl",
    CHANGE_FOC_STATE: "Common/ChangeFocState",
    DMS_REQUEST_INPROGRESS: "Common/DMS_REQUEST_INPROGRESS",
    DMS_API_ERROR: "Common/DMS_API_ERROR",
    DMS_API_SUCCESS: "Common/DMS_API_SUCCESS"
};

let initialState = {
    productTab: "",
    isFocSelected: false,
    productDetailsSelectedProductId: 0,
    retailerCurrentPosition: null,
    salesReturnReason: {
        isLoading: false,
        data: [],
        error: null
    },
    exchangeReturnReason: {
        isLoading: false,
        data: [],
        error: null
    },
    failedRequestUrl: "",

    /* DMS API Management */
    dmsApiInProgress: false,
    dmsApiError: false,
};

export const common = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_PRODUCT_TAB:
            return {
                ...state,
                productTab: action.payload.productTab
            };
        case types.CHANGE_FOC_STATE:
            return {
                ...state,
                isFocSelected: action.payload.isFocSelected
            };
        case types.SET_PRODUCT_DETAILS_SELECTED_PRODUCT_ID:
            return {
                ...state,
                productDetailsSelectedProductId: action.payload.productId
            };
        case types.SET_RETAILER_CURRENT_POSITION:
            return {
                ...state,
                retailerCurrentPosition: action.payload.currentPosition
            };
        case types.SET_FAILED_REQUEST_URL:
            return {
                ...state,
                failedRequestUrl: action.payload.failedRequestUrl
            };
        case types.DMS_API_ERROR:
            return {
                ...state,
                dmsApiError: true,
                dmsApiInProgress: false
            };
        case types.DMS_API_SUCCESS:
            return {
                ...state,
                dmsApiError: false,
                dmsApiInProgress: false
            };
        case types.DMS_REQUEST_INPROGRESS:
            return {
                ...state,
                dmsApiError: false,
                dmsApiInProgress: true
            };
        case types.SALES_RETURN_REASON_REQUEST:
        case types.SALES_RETURN_REASON_SUCCESS:
        case types.SALES_RETURN_REASON_FAILURE:
            return salesReturnReasonReducer(state, action);
        case types.EXCHANGE_RETURN_REASON_REQUEST:
        case types.EXCHANGE_RETURN_REASON_SUCCESS:
        case types.EXCHANGE_RETURN_REASON_FAILURE:
            return exchangeReturnReasonReducer(state, action);
        default:
            return state;
    }
};

const salesReturnReasonReducer = (state, action) => {
    switch (action.type) {
        case types.SALES_RETURN_REASON_REQUEST: {
            return {
                ...state,
                salesReturnReason: {
                    ...state.salesReturnReason,
                    isLoading: true
                }
            };
        }
        case types.SALES_RETURN_REASON_SUCCESS:
            return {
                ...state,
                salesReturnReason: {
                    ...action.payload,
                    error: null,
                    isLoading: false
                }
            };
        case types.SALES_RETURN_REASON_FAILURE:
            return {
                ...state,
                salesReturnReason: {
                    ...state.salesReturnReason,
                    error: action.payload.error,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};

const exchangeReturnReasonReducer = (state, action) => {
    switch (action.type) {
        case types.EXCHANGE_RETURN_REASON_REQUEST: {
            return {
                ...state,
                exchangeReturnReason: {
                    ...state.exchangeReturnReason,
                    isLoading: true
                }
            };
        }
        case types.EXCHANGE_RETURN_REASON_SUCCESS:
            return {
                ...state,
                exchangeReturnReason: {
                    ...action.payload,
                    error: null,
                    isLoading: false
                }
            };
        case types.EXCHANGE_RETURN_REASON_FAILURE:
            return {
                ...state,
                exchangeReturnReason: {
                    ...state.exchangeReturnReason,
                    error: action.payload.error,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};

/* Change the product listing tab */
export const changeProductTab = (tabName: String) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.CHANGE_PRODUCT_TAB,
            payload: { productTab: tabName }
        });
    };
};

/* Change the FOC state to true or false */
export const changeFocStatus = (status) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.CHANGE_FOC_STATE,
            payload: { isFocSelected: status }
        });
    };
};

/* Set product details selected product id */
export const setSelectedProductId = (productId: number) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SET_PRODUCT_DETAILS_SELECTED_PRODUCT_ID,
            payload: { productId: productId }
        });
    };
};

/* Set logged in retailer current position - lat and long */
export const setRetailerCurrentPosition = (currentPosition: IGeoLocationModel) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SET_RETAILER_CURRENT_POSITION,
            payload: { currentPosition: currentPosition }
        });
    };
};

/* Get the sales return reason types to show in the popup */
export const getSalesReturnReasons = () => {
    return async (dispatch, getState) => {
        let isShowSalesReturn: Boolean = getState().appSettings.isShowSalesReturn;
        if (isShowSalesReturn) {
            dispatch({ type: types.SALES_RETURN_REASON_REQUEST });
            try {
                const response = await getSalesReturnReasonsApi();

                const payload = {
                    data: response.data.Data
                };

                dispatch({
                    type: types.SALES_RETURN_REASON_SUCCESS,
                    payload
                });
            }
            catch (error) {
                dispatch(promiseCatchBlock(error, types.SALES_RETURN_REASON_FAILURE));
            }
        }
    }
};

/* Get the exchange return reason types to show in the popup */
export const getExchangeReturnReasons = () => {
    return async (dispatch, getState) => {
        let isEnableExchangeReturn: Boolean = getState().appSettings.isEnableExchangeReturn;
        if (isEnableExchangeReturn) {
            dispatch({ type: types.EXCHANGE_RETURN_REASON_REQUEST });
            try {
                const response = await getExchangeReturnReasonsApi();

                dispatch({
                    type: types.EXCHANGE_RETURN_REASON_SUCCESS,
                    payload: { data: response.data.Data }
                });
            }
            catch (error) {
                dispatch(promiseCatchBlock(error, types.EXCHANGE_RETURN_REASON_FAILURE));
            }
        }
    }
};

/* Navigate to query string landing page and focused tab */
export const navigateToDirectLink = (query: any) => {
    return async (dispatch, getState) => {
        const failedRequestUrl = getState().common.failedRequestUrl;

        if (failedRequestUrl === "") {
            /* Check for query string config */
            const { allowedQueryStringArray } = window;

            if (query && includes(allowedQueryStringArray, Constants.LANDING_SCREEN) && query.LS && query.LS !== "") {
                const landingScreen = query.LS;

                if (landingScreen === Constants.PRODUCT_LIST_SCREEN_NOTATION) {
                    if (includes(allowedQueryStringArray, Constants.FOCUSED_TAB) && query.FT && query.FT !== "") {
                        dispatch(navigateToProductList(query.FT));
                    }
                    else {
                        dispatch(navigateToProductList(""));
                    }
                }
                else {
                    dispatch(navigateToHome());
                }
            }
            else {
                const configSettings = getState().appSettings;
                if (configSettings.isLandingHomePage && configSettings.isEnableHomePage)
                    dispatch(navigateToHome());
                else
                    dispatch(navigateToProductList());
            }
        }
        else {
            dispatch(push(failedRequestUrl));
            dispatch(setFailedRequestUrl(""));
        }
    }
}

/* Update failed request url */
export const setFailedRequestUrl = (url: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SET_FAILED_REQUEST_URL,
            payload: { failedRequestUrl: url }
        });
    };
};

/* Get the message from multi language json files and display based on toast type */
export const showMsgFromJson = (path: string, type: string) => {
    return async (dispatch, getState) => {
        /* Restrict the alerts while session timeout, Only show the session timeout message*/
        if (appForceLogoutDisplayedCount === 0) {
            const translate = getTranslate(getState().locale);
            const message = translate(path);

            if (type === Constants.SUCCESS)
                successToast({ content: message });
            else if (type === Constants.INFO)
                infoToast({ content: message });
            else if (type === Constants.WARNING)
                warningToast({ content: message });
            else
                errorToast({ content: message });
        }
    };
};

/* Handle no app meta data available, Show the alert message and reload the whole page */
export const handleNoAppData = () => {
    return async (dispatch, getState) => {
        if (noAppDataDisplayedCount === 0) {
            /* Increment the noAppDataDisplayedCount to show the message at only one time */
            noAppDataDisplayedCount = (noAppDataDisplayedCount + 1);

            /* Show app data not available message */
            dispatch(showMsgFromJson("common.alerts.error.E000"), Constants.ERROR);

            /* Reload the page after 1.5 sec */
            setTimeout(() => { window.location = window.location.origin; }, 1500);
        }
    };
};

/* Handle the force logout error message and logout */
export const handleAppForceLogout = (errorCode: string) => {
    return async (dispatch, getState) => {
        /* Show session expired message */
        await dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`), Constants.ERROR);

        /* Increment the appForceLogoutDisplayedCount to show the message at only one time */
        appForceLogoutDisplayedCount = (appForceLogoutDisplayedCount + 1);

        /* Logout the retailer from the app and redirect to login page */
        await dispatch(logOut());

        /* Reload the page after 1 sec */
        setTimeout(() => { appForceLogoutDisplayedCount = 0 }, 1500);
    };
};

/* Track google analytics onMessage event */
export const logOnForegroundFcmMessage = () => {
    return async (dispatch) => {
        GAPushNotification(Constants.PUSH_NOTIFICATION_TYPE_FOREGROUND_MSG_DELIVERY);
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string) => {
    return (dispatch) => {
        const { message } = getErrorObject(error);
        dispatch({
            type: type,
            payload: { error: message }
        });
    }
};